// File: src/pages/Admin/GPTDocAgentAdmin.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config/config";

const GPTDocAgentAdmin = () => {
  const [filePath, setFilePath] = useState("src/routes/gptRoutes.js");
  const [folderPath, setFolderPath] = useState("src/routes");
  const [markdown, setMarkdown] = useState("");
  const [index, setIndex] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autodocStatus, setAutodocStatus] = useState(null);

  const runFileDoc = async () => {
    setLoading(true);
    setMarkdown("");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/doc/file`, { filePath });
      setMarkdown(`✅ Datei dokumentiert: ${res.data.file}\n\nGespeichert unter:\n${res.data.output}`);
    } catch (err) {
      console.error(err);
      setMarkdown("❌ Fehler bei der Dokumentation.");
    } finally {
      setLoading(false);
    }
  };

  const runFolderDoc = async () => {
    setLoading(true);
    setMarkdown("");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/doc/folder`, { folder: folderPath });
      setMarkdown(`📂 Ordner verarbeitet: ${res.data.processed} Dateien`);
    } catch (err) {
      console.error(err);
      setMarkdown("❌ Fehler bei der Ordnerdokumentation.");
    } finally {
      setLoading(false);
    }
  };

  const runAutoDocNow = async () => {
    setMarkdown("🚀 AutoDoc wird jetzt gestartet...");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/autodoc/trigger`);
      setMarkdown(`✅ AutoDoc abgeschlossen: ${res.data.result.updated} Datei(en) aktualisiert.`);
      loadIndex(); // Aktualisiere Index nach Doc-Update
      loadAutoDocStatus();
    } catch (err) {
      setMarkdown("❌ Fehler bei AutoDoc: " + err.message);
    }
  };

  const loadIndex = async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/api/gpt/doc/index`);
      setIndex(res.data.index);
    } catch (err) {
      console.error("❌ Fehler beim Laden des Index", err);
    }
  };

  const loadAutoDocStatus = async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/api/gpt/autodoc/status`);
      setAutodocStatus(res.data);
    } catch (err) {
      console.error("❌ Fehler beim Laden des AutoDoc-Status", err);
    }
  };

  useEffect(() => {
    loadIndex();
    loadAutoDocStatus();
  }, []);

  return (
    <div className="max-w-4xl mx-auto bg-gray-900 text-white p-6 rounded shadow-md">
      <h2 className="text-2xl font-bold mb-4">📘 GPT DocAgent – Dokumentations-Assistent</h2>

      <div className="mb-4">
        <label className="block font-semibold mb-1">📄 Einzeldatei dokumentieren</label>
        <input
          type="text"
          value={filePath}
          onChange={(e) => setFilePath(e.target.value)}
          className="w-full p-2 bg-gray-800 text-white rounded border border-gray-600 mb-2"
        />
        <button onClick={runFileDoc} disabled={loading} className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-600">
          {loading ? "Dokumentiert..." : "Dokumentation starten"}
        </button>
      </div>

      <div className="mb-6">
        <label className="block font-semibold mb-1">📂 Kompletten Ordner dokumentieren</label>
        <input
          type="text"
          value={folderPath}
          onChange={(e) => setFolderPath(e.target.value)}
          className="w-full p-2 bg-gray-800 text-white rounded border border-gray-600 mb-2"
        />
        <button onClick={runFolderDoc} disabled={loading} className="bg-green-600 px-4 py-2 rounded hover:bg-green-700">
          {loading ? "Scanne..." : "Ordner scannen & dokumentieren"}
        </button>
      </div>

      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">🧠 AutoDocEngine</h3>
        {autodocStatus && (
          <p className="mb-2 text-sm text-gray-400">
            Letzter Lauf:{" "}
            {new Date(autodocStatus.lastRun).toLocaleString("de-DE", {
              dateStyle: "short",
              timeStyle: "short"
            })}{" "}
            | Dateien im System: {autodocStatus.files}
          </p>
        )}
        <button
          onClick={runAutoDocNow}
          disabled={loading}
          className="bg-purple-600 hover:bg-purple-700 px-4 py-2 rounded"
        >
          Jetzt AutoDoc starten
        </button>
      </div>

      {markdown && (
        <div className="bg-gray-800 border border-gray-700 p-4 rounded text-sm whitespace-pre-wrap mb-6">
          {markdown}
        </div>
      )}

      <h3 className="text-xl font-semibold mb-2">📚 Inhaltsverzeichnis (`/docs`)</h3>
      <ul className="list-disc list-inside text-blue-300">
        {index.length > 0 ? (
          index.map((item, idx) => (
            <li key={idx}>
              <a href={item.path} target="_blank" rel="noopener noreferrer" className="hover:underline">
                {item.file}
              </a>
            </li>
          ))
        ) : (
          <li>Keine Dokumentation gefunden.</li>
        )}
      </ul>
    </div>
  );
};

export default GPTDocAgentAdmin;
